import { useEffect } from 'react';

interface Props {
  data: Record<string, unknown>;
}

export default function JsonLd({ data }: Props) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    script.setAttribute('data-page-jsonld', 'true');
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [data]);

  return null;
}